import { defineStore } from "pinia";
import { ref } from "vue";
import type { Project } from "~/types/projects";

export const useStoreProjects = defineStore("projets", () => {
  const projects = ref<Project[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const { getProjects } = useWordpressApi();

  /**
   * @description
   */
  const fetchProjects = async () => {

    isLoading.value = true;
    error.value = null;

    try {
      const data = await getProjects();
      projects.value = data;
      return data;
    } catch (err: any) {
      console.error("Erreur lors du fetch des projets :", err);
      error.value = "Impossible de charger les projets";
      return [];
    } finally {
      isLoading.value = false;
    }
  };

  return {
    projects,
    isLoading,
    error,
    fetchProjects,
  };
});
